import React, { type ReactNode } from 'react';

import type { MaybeChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
import { shouldBeChoreographed } from '@jira/platform__choreographer-services/src/utils.tsx';
import { withChoreographedRender } from '@jira/platform__choreographer-services/src/withChoreographedRender.tsx';

type ChildrenWrapperProps = { children: ReactNode };

const ChildrenWrapper = ({ children }: ChildrenWrapperProps) => <>{children}</>;
const ChoreographedChildrenWrapper = withChoreographedRender(ChildrenWrapper);

type ChoreographedComponentProps = MaybeChoreographedComponentProps & { children: ReactNode };

export const ChoreographedComponent = ({
	messageType,
	messageId,
	onMessageDisposition,
	children,
}: ChoreographedComponentProps): React.JSX.Element => {
	if (!shouldBeChoreographed({ messageId, messageType, onMessageDisposition })) {
		return <>{children}</>;
	}

	return (
		<ChoreographedChildrenWrapper messageId={messageId} onMessageDisposition={onMessageDisposition}>
			{children}
		</ChoreographedChildrenWrapper>
	);
};
